import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-4 mr-4"
}

import { ComputedRef, computed, WritableComputedRef } from "vue";
import { useStore } from "vuex";
import TwLabel from "../TwLabel.vue";
import TwTextarea from "../TwTextarea.vue";
import TwButtonsYesAndNo from "../TwButtonsYesAndNo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: '4.TakingMedicationsAndOthers',
  setup(__props) {

const store = useStore();

const areYouTakingMedicationsAndOthers: ComputedRef<boolean> = computed(
  () => store.state.form.are_you_taking_medications_and_others
);
const areYouTakingMedicationsAndOthersOral: WritableComputedRef<string> =
  computed({
    get: () => store.state.form.are_you_taking_medications_and_others_oral,
    set: (value) =>
      store.dispatch("updateAreYouTakingMedicationsAndOthersOral", value),
  });
const areYouTakingMedicationsAndOthersTopical: WritableComputedRef<string> =
  computed({
    get: () => store.state.form.are_you_taking_medications_and_others_topical,
    set: (value) =>
      store.dispatch("updateAreYouTakingMedicationsAndOthersTopical", value),
  });

const updateAreYouTakingMedicationsAndOthers = (value: boolean) => {
  store.dispatch("updateAreYouTakingMedicationsAndOthers", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[areYouTakingMedicationsAndOthers.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("are_you_taking_medications_and_others")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwButtonsYesAndNo, {
      isActive: areYouTakingMedicationsAndOthers.value,
      onOnClickYes: _cache[0] || (_cache[0] = ($event: any) => (updateAreYouTakingMedicationsAndOthers(true))),
      onOnClickNo: _cache[1] || (_cache[1] = ($event: any) => (updateAreYouTakingMedicationsAndOthers(false)))
    }, null, 8, ["isActive"]),
    (areYouTakingMedicationsAndOthers.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TwLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("oral")), 1)
            ]),
            _: 1
          }),
          _createVNode(TwTextarea, {
            modelValue: areYouTakingMedicationsAndOthersOral.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((areYouTakingMedicationsAndOthersOral).value = $event)),
            rows: 2,
            id: "areYouTakingMedicationsAndOthersOral"
          }, null, 8, ["modelValue"]),
          _createVNode(TwLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("topical")), 1)
            ]),
            _: 1
          }),
          _createVNode(TwTextarea, {
            modelValue: areYouTakingMedicationsAndOthersTopical.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((areYouTakingMedicationsAndOthersTopical).value = $event)),
            rows: 2,
            id: "areYouTakingMedicationsAndOthersTopical"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})